import React, { ChangeEvent } from "react";
import { toast } from "react-toastify";
import { Form, Input } from "edviron-ui-package";
// @ts-ignore
import studentsSample from "../../../../assets/sample__students.csv";

interface StudentUploadCSVProps {
  schoolId: string | null;
  schoolName?: string | null;
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const StudentUploadCSV: React.FC<StudentUploadCSVProps> = ({
  schoolId,
  handleFileChange,
}) => {
  const downloadSampleCSV = () => {
    const link = document.createElement("a");
    link.setAttribute("href", studentsSample);
    link.setAttribute("download", "sample_students.csv");
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success("Sample CSV file downloaded successfully");
  };

  if (!schoolId) {
    return null;
  }

  return (
    <div className="flex w-full">
      <div className="mx-auto w-full">
        <Form className="">
          <Input
            add_error={() => {}}
            type="file"
            accept=".csv"
            name="Upload CSV File"
            onChange={(e: any, v: React.ChangeEvent<HTMLInputElement>) => {
              handleFileChange(v);
            }}
            label="CSV File"
          />
          {/* ask */}
          <button
            type="button"
            className="text-sm ml-auto text-[#6687FF] cursor-pointer bg-transparent border-none p-0 hover:underline focus:outline-none"
            onClick={downloadSampleCSV}
          >
            Download Sample File
          </button>
        </Form>
      </div>
    </div>
  );
};

export default StudentUploadCSV;
